
<template>
    <div class="promotionError-component">
        <div><i class="ico ico-icon_59"></i></div>
        <div class="tips">抱歉，当前页面暂不能访问，请查看其他内容吧</div>
        <van-button type="danger" round @click="showDialog">点击查看更多</van-button>
        <app-guide-dialog ref="appGuideDialog" />
    </div>
</template>

<script >
import appGuideDialog from '@/components/appGuideDialog/appGuideDialog.vue'
import { Button } from 'vant'
export default {
    name: 'promotionError',
    components: {
        [Button.name]: Button,
        appGuideDialog
    },
    data () {
        return {

        }
    },
    created () {

    },
    activated () {

    },
    mounted () {

    },
    methods: {
        showDialog () {
            this.$refs.appGuideDialog.showStatus = true
        },
    }
}
</script>

<style lang="stylus" scoped>
@import "../../../assets/stylus/variables";

.promotionError-component
    width 100%
    text-align center
    padding-top 332px
    .tips
        margin 41px auto
        // width 344px
        width 380px
        font-size 28px
        line-height 36px
        color #999999
</style>
<style lang="stylus">
    .promotionError-component
        .van-button
            width 462px
            height 88px
            background-image linear-gradient(90deg, #ff5442 0%, #fc2d2d 100%), linear-gradient(#f3f3f3, #f3f3f3)
            border-radius 44px
            font-size 34px
</style>
